import {setDate, sub} from "date-fns";

import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {bigDataApiUrl} from "../../app/read_rp_environment_variables";
import {getOfferTypeNamePluralCapital} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";
import {getRegionToFetch} from "../hooks/use_region_estimated_price";
import {Country} from "../types/Country";
import {RegionType} from "../types/RegionType";
import {getRegionQueryParams, IRegionParam} from "./fetch_region_estimated_price";

export interface ISelectedRegionAveragePrices {
    date: string;
    slug_city: string;
    city: string;
    offer_type: string;
    avg_price: number;
    avg_price_studio: number;
    avg_price_2_rooms: number;
    avg_price_3_rooms: number;
    avg_price_4_plus_rooms: number;
}

export interface IFetchRegionAveragePriceParams {
    offerType: OfferType;
    region: {
        country: Country;
        full_name: string;
        id: number;
        stats?: {
            region_type_city?: {id: number} | null;
            region_type_county?: {id: number} | null;
            region_type_district?: {id: number} | null;
            region_type_town?: {id: number} | null;
            region_type_voivodeship?: {id: number} | null;
        };
        type: RegionType;
    };
}

export const fetchRegionAveragePrice = async (params: IFetchRegionAveragePriceParams): Promise<ISelectedRegionAveragePrices[]> => {
    const regionParams = getRegionToFetch(params.region) as IRegionParam;

    if (!regionParams) {
        return Promise.resolve([]);
    }

    const regionQueryParams = getRegionQueryParams(regionParams);
    const date = sub(new Date(), {months: 1});
    const fetchWithDistrict = regionParams.type === RegionType.DISTRICT;
    const link = fetchWithDistrict ? apiBigDataLink.monthDistrictTypeStats.base : apiBigDataLink.monthCityTypeStats.base;

    const query = {
        ...regionQueryParams,
        scenario: "rp-avg",
        offer_type: getOfferTypeNamePluralCapital(params.offerType),
        date_start: formatDate(sub(date, {months: 12}).toISOString(), dateTimeFormat.dashedDateFormat),
        date_end: formatDate(setDate(date, 1).toISOString(), dateTimeFormat.dashedDateFormat)
    };

    const url = appendQueryString(link(bigDataApiUrl), {...query});

    return await getExternalRequest({}, url, 5000);
};
import {setDate, sub} from "date-fns";

import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {bigDataApiUrl} from "../../app/read_rp_environment_variables";
import {getOfferTypeNamePluralCapital} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";
import {getRegionToFetch} from "../hooks/use_region_estimated_price";
import {Country} from "../types/Country";
import {RegionType} from "../types/RegionType";
import {getRegionQueryParams, IRegionParam} from "./fetch_region_estimated_price";

export interface ISelectedRegionAveragePrices {
    date: string;
    slug_city: string;
    city: string;
    offer_type: string;
    avg_price: number;
    avg_price_studio: number;
    avg_price_2_rooms: number;
    avg_price_3_rooms: number;
    avg_price_4_plus_rooms: number;
}

export interface IFetchRegionAveragePriceParams {
    offerType: OfferType;
    region: {
        country: Country;
        full_name: string;
        id: number;
        stats?: {
            region_type_city?: {id: number} | null;
            region_type_county?: {id: number} | null;
            region_type_district?: {id: number} | null;
            region_type_town?: {id: number} | null;
            region_type_voivodeship?: {id: number} | null;
        };
        type: RegionType;
    };
}

export const fetchRegionAveragePrice = async (params: IFetchRegionAveragePriceParams): Promise<ISelectedRegionAveragePrices[]> => {
    const regionParams = getRegionToFetch(params.region) as IRegionParam;

    if (!regionParams) {
        return Promise.resolve([]);
    }

    const regionQueryParams = getRegionQueryParams(regionParams);
    const date = sub(new Date(), {months: 1});
    const fetchWithDistrict = regionParams.type === RegionType.DISTRICT;
    const link = fetchWithDistrict ? apiBigDataLink.monthDistrictTypeStats.base : apiBigDataLink.monthCityTypeStats.base;

    const query = {
        ...regionQueryParams,
        scenario: "rp-avg",
        offer_type: getOfferTypeNamePluralCapital(params.offerType),
        date_start: formatDate(sub(date, {months: 12}).toISOString(), dateTimeFormat.dashedDateFormat),
        date_end: formatDate(setDate(date, 1).toISOString(), dateTimeFormat.dashedDateFormat)
    };

    const url = appendQueryString(link(bigDataApiUrl), {...query});

    return await getExternalRequest({}, url, 5000);
};
